import Dom from '../../helpers/dom-helper';
import toastSuccessTemplate from './html/toast-success.html';
import toastInfoTemplate from './html/toast-info.html';
import toastErrorTemplate from './html/toast-error.html';

class Toast {
    constructor(message, type) {
        this.element = Dom.createElement('<div></div>');
        this.element.innerHTML = this.getToastTemplate(type);

        const toastMessageEl = this.element.querySelector('.toast-message');
        toastMessageEl.innerHTML = message;
    }

    getToastTemplate(type) {
        switch (type) {
            case 'success':
                return toastSuccessTemplate();
            case 'info':
                return toastInfoTemplate();
            case 'error':
                return toastErrorTemplate();
            default:
                return toastSuccessTemplate();
        }
    }
}

export default class ToastService {
    constructor(toastContainer) {
        this.toastContainer = toastContainer;
        this.persistentToast = null; // Store reference to persistent toast
    }

    showToast(message, type = 'success', hideTimeout = 2500, width) {
        const HIDE_ANIMATION_TIME = 300;
        const toast = new Toast(message, type);

        this.toastContainer.appendChild(toast.element);

        this.toastContainer.style.maxWidth = '90%';

        if (width) {
            this.toastContainer.style.width = width + 'px';
        }

        setTimeout(() => {
            Dom.addClass('fade-out', toast.element.querySelector('.toast'));

            setTimeout(() => {
                this.toastContainer.removeChild(toast.element);
            }, HIDE_ANIMATION_TIME);
        }, hideTimeout);
    }

    /**
     * Show a persistent toast that won't auto-hide
     * @param {string} message - The message to display
     * @param {string} type - The type of toast ('success', 'info', 'error')
     * @param {number} width - Optional width in pixels
     * @returns {Toast} - Returns the toast instance for reference
     */
    showPersistentToast(message, type = 'info', width) {
        this.hidePersistentToast();

        const toast = new Toast(message, type);
        this.persistentToast = toast;

        this.toastContainer.appendChild(toast.element);

        this.toastContainer.style.maxWidth = '90%';

        if (width) {
            this.toastContainer.style.width = width + 'px';
        }

        return toast;
    }

    /**
     * Hide the current persistent toast
     */
    hidePersistentToast() {
        if (this.persistentToast && this.persistentToast.element.parentNode) {
            const HIDE_ANIMATION_TIME = 300;

            Dom.addClass('fade-out', this.persistentToast.element.querySelector('.toast'));

            setTimeout(() => {
                if (this.persistentToast && this.persistentToast.element.parentNode) {
                    this.toastContainer.removeChild(this.persistentToast.element);
                }
                this.persistentToast = null;
            }, HIDE_ANIMATION_TIME);
        }
    }

    /**
     * Update the message of the current persistent toast
     * @param {string} message - The new message to display
     */
    updatePersistentToastMessage(message) {
        if (this.persistentToast) {
            const toastMessageEl = this.persistentToast.element.querySelector('.toast-message');
            if (toastMessageEl) {
                toastMessageEl.innerHTML = message;
            }
        }
    }
}
